import React, { useContext } from "react";
import { ReactSVG } from "react-svg";

import downloadIcon from "../../../assets/svg/download.svg";
import { ROLES, normalizeRole } from "../../../auth/access";
import { UserContext } from "../../../UserContext";
import { StudentInfoContext } from "./StudentInfoContext";
import {
   fmtIsoDDMMYYYY_HHMM,
   translateAttemptStatus,
} from "./studentInfoShared";

function readExamTicketLabel(attempt) {
   const examTickets = Array.isArray(attempt?.examTickets)
      ? attempt.examTickets
      : Array.isArray(attempt?.tickets)
        ? attempt.tickets
        : [];
   const first = examTickets[0] || attempt?.ticket || null;
   const rawName = String(
      first?.ticket?.name ??
         first?.ticketName ??
         first?.name ??
         attempt?.ticketName ??
         "",
   ).trim();
   if (rawName) {
      const match = rawName.match(/(?:bilet(?:ul)?\s*)?(\d+)/i);
      return match?.[1] ? `Bilet ${match[1]}` : rawName;
   }

   const ticketId =
      first?.ticketId ?? first?.ticket?.id ?? attempt?.ticketId ?? null;
   return ticketId != null && String(ticketId).trim()
      ? `Bilet ${String(ticketId).trim()}`
      : "";
}

export default function StudentTheoryExamsTab() {
   const { user } = useContext(UserContext) || {};
   const role = normalizeRole(user?.role);
   const showTicketNumber = role === ROLES.ADMIN || role === ROLES.MANAGER;
   const {
      attemptsLoading,
      attemptsError,
      downloadError,
      attempts,
      handleDownloadPdf,
      downloadingId,
   } = useContext(StudentInfoContext);

   return (
      <div className="studentsProfileUI__attempts">
         {attemptsLoading && <p>Se încarcă încercările…</p>}
         {attemptsError && (
            <p className="students-info__error">{attemptsError}</p>
         )}
         {downloadError && (
            <p className="students-info__error">Descărcare: {downloadError}</p>
         )}

         {!attemptsLoading && !attemptsError && attempts.length === 0 && (
            <p className="students-info__empty">Nu există încercări.</p>
         )}

         {!attemptsLoading && !attemptsError && attempts.length > 0 && (
            <div className="studentsProfileUI__attemptsList">
               {attempts.slice(0, 50).map((a, idx) => {
                  const eid = a.examId ?? a.id;
                  const status = String(a.status || "UNKNOWN").toLowerCase();
                  const statusLabel = translateAttemptStatus(
                     a.status || "UNKNOWN",
                  );
                  const ticketLabel = showTicketNumber
                     ? readExamTicketLabel(a)
                     : "";
                  const resultLabel = ticketLabel
                     ? `${statusLabel} - ${ticketLabel}`
                     : statusLabel;

                  const started = a.startedAt
                     ? fmtIsoDDMMYYYY_HHMM(a.startedAt)
                     : "–";
                  const finished = a.finishedAt
                     ? fmtIsoDDMMYYYY_HHMM(a.finishedAt)
                     : null;
                  const lineLeft = finished
                     ? `${started} → ${finished}`
                     : started;

                  const scoreText =
                     a.scorePct != null
                        ? `${Math.round(a.scorePct)}%`
                        : a.correct != null && a.total != null
                          ? `${a.correct}/${a.total}`
                          : "–";

                  return (
                     <div
                        key={(a.id ?? eid ?? "attempt") + "-" + idx}
                        className={`studentsProfileUI__attempt studentsProfileUI__attempt--${status}`}
                     >
                        <div className="studentsProfileUI__attemptLeft">
                           <div className="studentsProfileUI__attemptStatus">
                              {resultLabel}
                           </div>
                           <div className="studentsProfileUI__attemptDates">
                              {lineLeft}
                           </div>
                        </div>

                        <div className="studentsProfileUI__attemptRight">
                           <div className="studentsProfileUI__attemptScore">
                              {scoreText}
                           </div>
                           {a.total != null && (
                              <div className="studentsProfileUI__attemptTotal">
                                 {a.total} întrebări
                              </div>
                           )}
                        </div>

                        {eid && (
                           <button
                              type="button"
                              onClick={(e) => {
                                 e.stopPropagation();
                                 handleDownloadPdf(eid);
                              }}
                              className="studentsProfileUI__attemptDownload"
                              title={
                                 downloadingId === eid
                                    ? "Se descarcă..."
                                    : "Descarcă rezultatul (PDF)"
                              }
                              disabled={downloadingId === eid}
                           >
                              <ReactSVG
                                 src={downloadIcon}
                                 className={
                                    "studentsProfileUI__item-icon is-download" +
                                    (downloadingId === eid ? " is-loading" : "")
                                 }
                              />
                           </button>
                        )}
                     </div>
                  );
               })}
            </div>
         )}
      </div>
   );
}
